"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionMoreActions_1 = require("../../../../../../../../shared/components/table_actions/TableActionMoreActions");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var ToolBarDateRangeFilter_1 = require("../../../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var PlayerMessagesList = /** @class */ (function (_super) {
    __extends(PlayerMessagesList, _super);
    function PlayerMessagesList(props) {
        var _this = _super.call(this, props) || this;
        _this.action_more_set_readed = "action:set-readed";
        _this.action_more_set_unread = "action:set-unread";
        _this.columns = [
            {
                title: 'Дата создания',
                dataIndex: _this.props.dataMessages.dk_date_added,
                key: _this.props.dataMessages.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Игрок',
                key: "v-" + _this.props.dataMessages.dk_title,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.player.login));
                },
                width: 200,
            }, , {
                title: 'Дата изменения',
                dataIndex: _this.props.dataMessages.dk_date_changed,
                key: _this.props.dataMessages.dk_date_changed,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Дата прочтения',
                dataIndex: _this.props.dataMessages.dk_date_readed,
                key: _this.props.dataMessages.dk_date_readed,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_readed.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Тема сообщения',
                dataIndex: _this.props.dataMessages.dk_title,
                key: _this.props.dataMessages.dk_title,
                width: 200,
            }, {
                title: 'Прочитано',
                dataIndex: _this.props.dataMessages.dk_is_readed,
                key: _this.props.dataMessages.dk_is_readed,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.bool2str(record.is_readed)));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }),
                    React.createElement(TableActionMoreActions_1.default, { hint: "\u0415\u0449\u0435", menu: _this.getMoreActionsDropDownMenu(record) }))); },
                width: 80
            }
        ];
        return _this;
    }
    PlayerMessagesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataMessages.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat,
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: [],
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
            unread_messages: this.props.isShowOnlyUnreadMessages
        }, function () {
            _this.loadData(_this.props);
        });
    };
    PlayerMessagesList.prototype.componentWillUnmount = function () {
        this.props.dataMessages.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PlayerMessagesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
                unread_messages: nextProps.isShowOnlyUnreadMessages
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    PlayerMessagesList.prototype.loadData = function (Props, onDone) {
        if (this.state.unread_messages) {
            Props.dataMessages.LoadUnreadedData(Props.player.key, function () {
                if (onDone) {
                    onDone();
                }
            });
        }
        else {
            Props.dataMessages.LoadRangeData({
                playerId: Props.player.key,
                from_year: this.state.dtFrom.get('year'),
                from_month: this.state.dtFrom.get('month') + 1,
                from_day: this.state.dtFrom.get('date'),
                from_hour: this.state.dtFrom.get('hour'),
                from_minute: this.state.dtFrom.get('minute'),
                to_year: this.state.dtTo.get('year'),
                to_month: this.state.dtTo.get('month') + 1,
                to_day: this.state.dtTo.get('date'),
                to_hour: this.state.dtTo.get('hour'),
                to_minute: this.state.dtTo.get('minute'),
            }, function () {
                if (onDone) {
                    onDone();
                }
            });
        }
    };
    PlayerMessagesList.prototype.bool2str = function (val) {
        if (val) {
            return "Да";
        }
        else {
            return "Нет";
        }
    };
    PlayerMessagesList.prototype.onDeleteClick = function (record) {
        this.props.dataMessages.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E"));
        });
    };
    PlayerMessagesList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_readed },
                React.createElement(FontAwesome_1.FA, { icon: "envelope-open", left: true }),
                "\u041E\u0442\u043C\u0435\u0442\u0438\u0442\u044C \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u043E\u0435"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_more_set_unread },
                React.createElement(FontAwesome_1.FA, { icon: "envelope", left: true }),
                "\u041E\u0442\u043C\u0435\u0442\u0438\u0442\u044C \u043A\u0430\u043A \u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u043E\u0435")));
    };
    PlayerMessagesList.prototype.doMorection = function (e, record) {
        var _this = this;
        var _readed = false;
        if (e.key == this.action_more_set_readed) {
            _readed = true;
        }
        if (e.key == this.action_more_set_unread) {
            _readed = false;
        }
        this.props.dataMessages.SetIsReaded(record.key, _readed, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0421\u0442\u0430\u0442\u0443\u0441 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0438\u0433\u0440\u043E\u043A\u0443 ",
                React.createElement("b", null,
                    "[",
                    _this.props.player.login,
                    "]"),
                " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
        });
    };
    PlayerMessagesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PlayerMessagesList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "create") {
            this.props.dlgMessage.clearFields().SetDialogTitle("Новое сообщение игроку")
                .SetMessageBody("")
                .SetMessageTitle("")
                .SetOnYesClick(function (messageTitle, messageBody /*, isHasPromo, promoCode, isImportant*/) {
                _this.props.dataMessages.AddData({
                    message: messageBody,
                    title: messageTitle,
                    usr_player_id: _this.props.player.key,
                }, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0443 ",
                        React.createElement("b", null,
                            "[",
                            _this.props.player.login,
                            "]"),
                        " \u0441\u043E\u0437\u0434\u0430\u043D\u043E !"));
                });
            }).Show();
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PlayerMessagesList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    PlayerMessagesList.prototype.onCheckBoxChecked = function (checked) {
        if (this.props.onShowOnlyUnreadMessagesClick) {
            this.props.onShowOnlyUnreadMessagesClick(checked);
        }
    };
    PlayerMessagesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", create: "Создать", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, "\u0412\u0441\u0435 \u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435"),
                React.createElement(antd_1.Switch, { checked: this.state.unread_messages, onChange: this.onCheckBoxChecked.bind(this) }),
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this), disabled: this.state.unread_messages })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.state.dtFormat),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A:"),
                            " [",
                            _this.props.player.login,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0422\u0435\u043A\u0441\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F:"),
                            " [",
                            record.message,
                            "]")));
                }, scroll: { x: true } })));
    };
    return PlayerMessagesList;
}(React.Component));
exports.default = PlayerMessagesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/messages_list/PlayerMessagesList.tsx
// module id = 1924
// module chunks = 0